export default "__VITE_ASSET__9fbde662__"